import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import { IrqTitle } from "../molecules/IrqTitle";
import IrqChoiceButtons from "../molecules/IrqChoiceButtons";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import ILearn from "../molecules/ILearn";

class IrqCitizenView extends Component {
  render() {
    const values = [true, false];
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/us_citizen.svg"
          />
          <IrqChoiceButtons
            content={this.props.content}
            value={this.props.data.isUsCitizen}
            values={values}
            onChoiceMade={(index) => {
              this.props.customFormEdit("isUsCitizen", values[index]);
              this.props.navigationContext.goNext(
                this.props.navigationsAway.Primary,
                true
              );
            }}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqCitizenView));
